export default "__VITE_ASSET__B7pW3y0N__"